import React, { useState, useEffect } from "react"
import PubSub from "pubsub-js"
import { _getLocalizedText } from '../../core/utils'

const Burger = () => {
	const [active, setActive] = useState(false)

	useEffect(() => {
		const tokenRouteUpdate = PubSub.subscribe("ROUTE_UPDATE", () => {
			setActive(false)
		})

		const tokenBurger = PubSub.subscribe("BURGER.CLOSE", () => {
			setActive(false)
			PubSub.publish("BURGER", false)
		})

		return () => {
			PubSub.unsubscribe(tokenRouteUpdate)
			PubSub.unsubscribe(tokenBurger)
		}
	}, [])

	const _onClick = () => {
		const next = !active
		setActive(next)
		PubSub.publish("BURGER", next)
	}

	const burgerClass = active ? "active" : ""
	return (
		<button
			className={"burger-wrapper sm-only curp fS " + burgerClass}
			onClick={_onClick}
			aria-label={active ? _getLocalizedText("closeMenu") : _getLocalizedText("openMenu")}
			aria-expanded={active}
		>
			{active
			? <span>{_getLocalizedText("close")}</span>
			: <span>{_getLocalizedText("menu")}</span>
			}
		</button>
	)
}

export default Burger
